import { render } from "./AttPerformance.vue?vue&type=template&id=45ca97b0&scoped=true"
import script from "./AttPerformance.vue?vue&type=script&lang=js"
export * from "./AttPerformance.vue?vue&type=script&lang=js"

import "./AttPerformance.vue?vue&type=style&index=0&id=45ca97b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ca97b0"]])

export default __exports__